// availability
export const UPDATE_HEARTBEATS        = 'UPDATE_HEARTBEATS'
export const UPDATE_DATE              = 'UPDATE_DATE'
export const UPDATE_TIME              = 'UPDATE_TIME'
export const UPDATE_LOCATION          = 'UPDATE_LOCATION'
export const UPDATE_PARTY_SIZE        = 'UPDATE_PARTY_SIZE'
export const UPDATE_FIRST_TIMESLOT    = 'UPDATE_FIRST_TIMESLOT'
export const UPDATE_LAST_TIMESLOT     = 'UPDATE_LAST_TIMESLOT'
export const UPDATE_DISABLE_SEARCH    = 'UPDATE_DISABLE_SEARCH'
export const SET_SUGGESTED_TIMES      = 'SET_SUGGESTED_TIMES'
export const CLEAR_SUGGESTED_TIMES    = 'CLEAR_SUGGESTED_TIMES'
export const SELECT_SUGGESTED_TIME    = 'SELECT_SUGGESTED_TIME'
export const SET_SHOW_PAGE            = 'SET_SHOW_PAGE'

// userInfo
export const UPDATE_FIRST_NAME         = 'UPDATE_FIRST_NAME'
export const UPDATE_LAST_NAME          = 'UPDATE_LAST_NAME'
export const UPDATE_PHONE              = 'UPDATE_PHONE'
export const UPDATE_PHONE_CONFIRMATION = 'UPDATE_PHONE_CONFIRMATION'

export const UPDATE_EMAIL              = 'UPDATE_EMAIL'
export const UPDATE_EMAIL_CONFIRMATION = 'UPDATE_EMAIL_CONFIRMATION'
export const UPDATE_CAKE               = 'UPDATE_CAKE'
export const UPDATE_OCCASION           = 'UPDATE_OCCASION'
export const UPDATE_ACCEPT_POLICY      = 'UPDATE_ACCEPT_POLICY'
export const UPDATE_CONFIRMATION_CODE  = 'UPDATE_CONFIRMATION_CODE'
export const CLEAR_VALIDATION_FAILURE  = 'CLEAR_VALIDATION_FAILURE'
export const ADD_VALIDATION_FAILURE    = 'ADD_VALIDATION_FAILURE'
export const SET_RES_TOKEN             = 'SET_RES_TOKEN'
export const UPDATE_RES_DELETED        = 'UPDATE_RES_DELETED'